import { Channel, getChannelNumber } from '@kaltura-ott/tvpil-shared';

export function addVirtualNumbers(channels: Array<Channel>) {
  return channels.map((channel) => ({
    ...channel,
    virtualNumber: getChannelNumber(channel),
  }));
}
